export default __webpack_public_path__ + "static/media/icon-disabled- credit-card.f8a00f1f.svg";